import { NgModule } from "@angular/core";
import { CommonModule, DatePipe, DecimalPipe } from "@angular/common";
import { ArrayFilterPipe } from "./array-filter.pipe";
import { NotOwnUuidPipe } from "./not-own-uuid.pipe";
import { FormArrayPipe } from "./form-array.pipe";
import { FormControlPipe } from "./form-control.pipe";
import { FormGroupPipe } from "./form-group.pipe";
import { PreisNumberPipe } from "./preis-number.pipe";
import { IdSingleSelectPipe } from "./id-single-select.pipe";
import { DateRangePipe } from "./date-range.pipe";
import { PermissionPipe } from "./permission.pipe";
import { GetControlPipe } from "./get-control.pipe";
import { PropertySummePipe } from "./property-summe.pipe";
import { RawValuePipe } from "./raw-value.pipe";
import { ArrayUniquePipe } from "./array-unique.pipe";
import { FilterEmployeesByEmployeePipe } from "./filter-employees-by-employee.pipe";

@NgModule({
  declarations: [
    ArrayFilterPipe,
    NotOwnUuidPipe,
    FormArrayPipe,
    FormControlPipe,
    FormGroupPipe,
    PreisNumberPipe,
    IdSingleSelectPipe,
    DateRangePipe,
    PermissionPipe,
    GetControlPipe,
    PropertySummePipe,
    RawValuePipe,
    ArrayUniquePipe,
    FilterEmployeesByEmployeePipe,
  ],
  imports: [CommonModule],
  exports: [
    ArrayFilterPipe,
    NotOwnUuidPipe,
    FormArrayPipe,
    FormControlPipe,
    FormGroupPipe,
    PreisNumberPipe,
    IdSingleSelectPipe,
    DateRangePipe,
    PermissionPipe,
    GetControlPipe,
    PropertySummePipe,
    RawValuePipe,
    ArrayUniquePipe,
    FilterEmployeesByEmployeePipe,
  ],
  providers: [DecimalPipe, DatePipe],
})
export class PipeModule {}
